import styled from 'styled-components'
import { BaseInput } from 'components/Inputs/Base'
import { LookButton, iconButtonLook } from 'components/Buttons/look'

export const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  position: relative;
`

/* Com o X, o texto não passa por baixo dele. */
export const Input = styled(BaseInput)`
  ${({ $withAction }) => $withAction && 'padding-right: 36px;'}
`

export const ClearButton = styled(LookButton).attrs({ type: 'button' }).attrs(iconButtonLook())`
  position: absolute;
  right: 4px;
`
